import { render } from "./WhatsAppProfileView.vue?vue&type=template&id=d5a41fae&scoped=true"
import script from "./WhatsAppProfileView.vue?vue&type=script&lang=js"
export * from "./WhatsAppProfileView.vue?vue&type=script&lang=js"

import "./WhatsAppProfileView.vue?vue&type=style&index=0&id=d5a41fae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d5a41fae"]])

export default __exports__